const EditIntent = ({
	intents,
	intent,
	handleIntentsSelectChange,
}) => {

	if (!intent) return null;

	return <div className="service-modal__step-two">
		<p className="service-modal__text">and I want</p>
		<select name="intents" className="service-modal__select" onChange={handleIntentsSelectChange} value={intent?.slug}>
			{intents.map(i => (
				<option value={i.slug} key={i.slug}>
					{i.name}
				</option>
			))}
		</select>
	</div>;
}
 
export default EditIntent;